import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito muchos seguidores para que esto funcione?',
    a: 'No. El sistema está diseñado específicamente para Networkers con audiencias pequeñas. El algoritmo de Instagram en 2026 premia la relevancia del contenido, no el tamaño de la cuenta. Varios estudiantes del plan han recibido sus primeros mensajes de prospectos con menos de 300 seguidores.'
  }, {
    q: '¿Es apto para cualquier empresa de MLM?',
    a: 'Sí. El Sistema Magnético se basa en marketing de atracción digital, no en ninguna empresa específica. Funciona para Herbalife, Omnilife, Forever Living, QNET, Amway, Monat o cualquier red de distribución activa en redes sociales.'
  }, {
    q: '¿Cuánto tiempo al día necesito dedicarle?',
    a: 'El plan está diseñado para ejecutarse en 45 minutos diarios durante 7 días. Si tienes empleo de tiempo completo, puedes hacerlo en las mañanas antes de trabajar o en las noches. La tarea de cada día es específica y no requiere más tiempo del indicado.'
  }, {
    q: '¿Cuándo voy a ver los primeros resultados?',
    a: 'Los primeros resultados visibles — comentarios orgánicos, nuevos seguidores calificados y mensajes de curiosos — generalmente aparecen entre el Día 3 y el Día 7 si aplicas cada tarea sin saltarte pasos. El ritmo exacto depende de la frecuencia con que publiques durante los 7 días.'
  }, {
    q: '¿Necesito saber de diseño o edición de video?',
    a: 'No. Los Bonos #1 y #2 están incluidos precisamente para eso. Las plantillas de Canva son editables en menos de 5 minutos sin conocimientos de diseño. Para los videos, el plan te enseña a grabar con el celular de forma natural. No necesitas producción profesional.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Sí. Una vez que compras, el acceso es tuyo para siempre incluyendo cualquier actualización futura del material. No hay suscripción ni pagos adicionales.'
  }, {
    q: '¿Qué pasa si no veo resultados?',
    a: 'Tienes 30 días de garantía total. Si aplicas el plan completo y no notas ningún cambio en tu perfil ni en la interacción de tu audiencia, te devolvemos el dinero sin preguntas. El riesgo es completamente nuestro.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-darker px-6 py-20 md:py-28 border-t border-slate-800" data-id="element-54">
      <div className="mx-auto max-w-3xl" data-id="element-55">
        <div className="text-center mb-12" data-id="element-56">
          <div className="inline-flex items-center justify-center p-3 bg-brand-light rounded-full mb-4 border border-slate-700" data-id="element-57">
            <HelpCircle className="w-8 h-8 text-slate-300" data-id="element-58" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-59">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-60">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-light border border-slate-800 rounded-xl overflow-hidden" data-id="element-61">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-62">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-63">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" />
              </button>

              <AnimatePresence data-id="element-65">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-66">
                    <div className="px-6 pb-5 text-slate-400 border-t border-slate-800/50 pt-4" data-id="element-67">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}